import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const startShopperAgentSplit = {
  name: "startShopperAgentSplit" as const,
  input: z.object({
    teamId: zExt.objectId(),
    name: z.string().min(1),
    /**
     * Buckets [0..999] assigned to the *treatment* arm. Customers whose
     * deterministic md5 bucket (NUM_BUCKETS=1000) lands outside this set
     * get HOLDOUT. Pass e.g. [0..499] for a 50/50 split, [0..899] for a
     * 10% holdout.
     */
    treatmentBuckets: z.array(z.number().int().min(0).max(999)).min(1),
    /**
     * Order attribution window. Defaults to 90 days to match the
     * ShopperAgentSplit schema default; tighten for shorter tests.
     */
    attributionWindowDays: z.number().int().positive().optional(),
  }),
  output: z.object({ splitId: zExt.objectId() }),
};
